import { render, staticRenderFns } from "./Top-logo.vue?vue&type=template&id=198dadc2&scoped=true&"
import script from "./Top-logo.vue?vue&type=script&lang=js&"
export * from "./Top-logo.vue?vue&type=script&lang=js&"
import style0 from "./Top-logo.scss?vue&type=style&index=0&id=198dadc2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198dadc2",
  null
  
)

export default component.exports